import { render, staticRenderFns } from "./ConfigPage.vue?vue&type=template&id=b4bb3160&scoped=true"
import script from "./ConfigPage.vue?vue&type=script&lang=js"
export * from "./ConfigPage.vue?vue&type=script&lang=js"
import style0 from "./ConfigPage.vue?vue&type=style&index=0&id=b4bb3160&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4bb3160",
  null
  
)

export default component.exports